var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1131_83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mdi:telephone",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1131_83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.62012 10.79C8.06006 13.6201 10.3799 15.9404 13.21 17.3799L15.4099 15.1797C15.6899 14.9004 16.0801 14.8203 16.4299 14.9297C17.55 15.2998 18.75 15.5 20 15.5C20.2651 15.5 20.5195 15.6055 20.707 15.793C20.8945 15.9805 21 16.2344 21 16.5L21 20C21 20.2656 20.8945 20.5195 20.707 20.707C20.5195 20.8945 20.2651 21 20 21C15.4912 21 11.1672 19.209 7.97925 16.0205C4.79102 12.833 3 8.50879 3 4C3 3.73438 3.10547 3.48047 3.29297 3.29297C3.48047 3.10547 3.73486 3 4 3L7.5 3C7.76514 3 8.01953 3.10547 8.20703 3.29297C8.39453 3.48047 8.5 3.73438 8.5 4C8.5 5.25 8.69995 6.4502 9.07007 7.57031C9.17993 7.91992 9.1001 8.30957 8.82007 8.58984L6.62012 10.79Z",
    fill: "#BABBD0",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelephone);
export default __webpack_public_path__ + "static/media/ic_telephone.8d8e728495f4b8a878004f11531971c9.svg";
export { ForwardRef as ReactComponent };